//https://www.typescriptlang.org/docs/handbook/interfaces.html
declare const require: (moduleId:string) => any;
const wbs: any = require("@nodeject/wbs"); 
//export const NODE_KINDS = wbs.nodeKinds;
export const NODE_KINDS = (wbs === undefined) ? 1 : wbs.nodeKinds;

export interface AddWbsComponentEvents {
  onAddChild?(parentId: string, title: string, nodeKind: number): void;
  onInsertParent?(nodeId: string, title: string, nodeKind: number): void;
  onAddSiblingBefore?(nodeId: string, title: string, nodeKind: number): void;
  onAddSiblingAfter?(nodeId: string, title: string, nodeKind: number): void;
}

export interface SelectNodeEvents {
  onComponentSelected?(nodeId: string): void;
  onComponentOpenMenu?(nodeId: string): void;
}

export interface EditNodeEvents {
  onTitleEditRequest?(nodeId: string, title: string): void;
}


// WEBPACK FOOTER //
// ./src/WbsEvents.ts